(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-video"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function fmt(s) { s = Math.max(0, Math.floor(s || 0)); return Math.floor(s / 60) + ':' + String(s % 60).padStart(2, '0'); }
    document.querySelectorAll('[data-hv-film]').forEach(function (p) {
      var btn = p.querySelector('.hv__play'), ctrl = p.querySelector('.hv__ctrl'), end = p.querySelector('.hv__end');
      var bar = p.querySelector('[data-hv-bar]'), fill = p.querySelector('[data-hv-fill]'), knob = p.querySelector('[data-hv-knob]');
      var tEl = p.querySelector('[data-hv-time]'), dEl = p.querySelector('[data-hv-dur]');
      var video = null, idle = null;
      function wake() {
        p.classList.remove('hv--idle');
        clearTimeout(idle);
        if (video && !video.paused) idle = setTimeout(function () { p.classList.add('hv--idle'); }, 2600);
      }
      function sync() {
        if (!video) return;
        var r = video.duration ? video.currentTime / video.duration : 0;
        fill.style.width = (r * 100) + '%'; knob.style.left = (r * 100) + '%';
        bar.setAttribute('aria-valuenow', Math.round(r * 100));
        tEl.textContent = fmt(video.currentTime); dEl.textContent = fmt(Math.round(video.duration || 0));
      }
      function build() {
        var tpl = p.querySelector('[data-hv-video-template]');
        if (tpl) { p.insertBefore(tpl.content.cloneNode(true), ctrl); video = p.querySelector('video'); }
        else {
          video = document.createElement('video');
          video.src = (window.innerWidth < 920 && p.dataset.sd) ? p.dataset.sd : p.dataset.hd;
          video.preload = 'auto';
          p.insertBefore(video, ctrl);
        }
        video.removeAttribute('controls'); video.playsInline = true; video.setAttribute('playsinline', '');
        video.addEventListener('timeupdate', sync);
        video.addEventListener('loadedmetadata', sync);
        video.addEventListener('play', function () { p.classList.remove('hv--paused'); btn.setAttribute('aria-hidden', 'true'); ctrl.querySelector('[data-hv-toggle]').setAttribute('aria-label', 'Pause'); wake(); });
        video.addEventListener('pause', function () { p.classList.add('hv--paused'); ctrl.querySelector('[data-hv-toggle]').setAttribute('aria-label', 'Abspielen'); wake(); });
        video.addEventListener('volumechange', function () { p.classList.toggle('hv--muted', video.muted); ctrl.querySelector('[data-hv-mute]').setAttribute('aria-label', video.muted ? 'Ton an' : 'Ton aus'); });
        video.addEventListener('ended', function () { end.hidden = false; ctrl.hidden = true; p.classList.remove('hv--idle'); if (document.fullscreenElement) document.exitFullscreen(); });
        video.addEventListener('click', function () { video.paused ? video.play() : video.pause(); });
      }
      btn.addEventListener('click', function () {
        if (!video) build();
        p.classList.add('hv--playing'); ctrl.hidden = false; end.hidden = true;
        video.play();
      });
      ctrl.querySelector('[data-hv-toggle]').addEventListener('click', function () { video.paused ? video.play() : video.pause(); });
      ctrl.querySelector('[data-hv-mute]').addEventListener('click', function () { video.muted = !video.muted; });
      ctrl.querySelector('[data-hv-fs]').addEventListener('click', function () {
        if (document.fullscreenElement) return document.exitFullscreen();
        if (p.requestFullscreen) p.requestFullscreen(); else if (video.webkitEnterFullscreen) video.webkitEnterFullscreen();
      });
      function seek(e) { var r = bar.getBoundingClientRect(); var x = (e.touches ? e.touches[0].clientX : e.clientX); video.currentTime = Math.min(1, Math.max(0, (x - r.left) / r.width)) * video.duration; sync(); }
      bar.addEventListener('click', seek);
      bar.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { video.currentTime = Math.min(video.duration, video.currentTime + 5); e.preventDefault(); }
        if (e.key === 'ArrowLeft') { video.currentTime = Math.max(0, video.currentTime - 5); e.preventDefault(); }
      });
      p.querySelector('[data-hv-replay]').addEventListener('click', function () { video.currentTime = 0; end.hidden = true; ctrl.hidden = false; video.play(); });
      ['mousemove', 'touchstart', 'focusin'].forEach(function (ev) { p.addEventListener(ev, wake, { passive: true }); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["referenz"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var section = document.getElementById('rf-referenz');
    if (!section) return;
    var haupt = section.querySelector('.rf__img--haupt');
    var chip = section.querySelector('[data-chip]');
    var kacheln = section.querySelectorAll('.rf__kachel');
    if (!haupt || !kacheln.length) return;
    kacheln.forEach(function (k) {
      k.addEventListener('click', function () {
        var full = k.dataset.full;
        if (!full || haupt.currentSrc === full) return;
        kacheln.forEach(function (o) { o.classList.toggle('is-active', o === k); });
        if (chip) {
          var label = k.dataset.label || '';
          chip.textContent = label;
          chip.hidden = !label;
        }
        haupt.classList.add('is-wechsel');
        var tausch = function () {
          haupt.removeAttribute('srcset');
          haupt.removeAttribute('sizes');
          haupt.src = full;
          haupt.onload = function () { haupt.classList.remove('is-wechsel'); };
        };
        setTimeout(tausch, 180);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
